export default "__VITE_PUBLIC_ASSET__b26b784d__"